module.exports = __webpack_public_path__ + "img/success_gou_icon.194dd64c.png";